export const URLS = {
  home: "/",
  product: "/product",
  joinUs: "/join",
  redirectToDownload: "/download",
  Login: "/auth/login",
  SignUp: "/auth/signup",
  Jobs: "/jobs",
  JobsDashboard: "/jobs/dashboard",
  JobsCreate: "/jobs/create",
  JobsEdit: "/jobs/edit/:id",
  Auth: "/auth",
};

const androidWalletLink =
  import.meta.env.VITE_ANDROID_APP_LINK ||
  "https://play.google.com/store/apps/details?id=net.token13.wallet";
const iosWalletLink = import.meta.env.VITE_IOS_APP_LINK || "/";
const iosExplorerLink =
  import.meta.env.VITE_IOS_EXPLORER_APP_LINK ||
  "https://apps.apple.com/us/app/tokenb-explorer/id6747426865";
const otherlinks = import.meta.env.VITE_OTHER_LINKS || "/";

export const DEVICES = {
  wallet: {
    android: {
      name: "android",
      url: androidWalletLink,
      isSupported: true,
    },
    ios: { name: "ios", url: iosWalletLink, isSupported: false },
    mac: { name: "mac", url: iosWalletLink, isSupported: false },
    other: { name: "other", url: otherlinks, isSupported: false },
  },
  explorer: {
    android: {
      name: "android",
      url: otherlinks,
      isSupported: false,
    },
    ios: {
      name: "ios",
      url: iosExplorerLink,
      isSupported: true,
    },
    mac: { name: "mac", url: iosExplorerLink, isSupported: true },
    other: {
      name: "other",
      url: otherlinks,
      isSupported: true,
    },
  },
};

export const Status = {
  "403_FORBIDDEN": 403,
  "401_UNAUTHORIZED": 401,
  "400_BAD_REQUEST": 400,
};
